module.exports = __webpack_public_path__ + "img/team-footer-bg.dd4c8cbb.svg";